export default import.meta.ROLLDOWN_FILE_URL_L9$JtIHTb8LwAJcRaXbAYQ